<template>
    <b-container id="tickets-container" fluid>
        <div id="tabs">
            <ul>
                <li @click="selectedTab = 'date'">
                    <a href="#tabs-data"><i class="fas fa-calendar-day"></i> Data</a>
                </li>

                <li @click="selectedTab = 'client'">
                    <a href="#tabs-client"><i class="fas fa-users"></i> Cliente</a>
                </li>

                <li @click="selectedTab = 'owner'">
                    <a href="#tabs-owner"><i class="fas fa-address-card"></i> Usuário</a>
                </li>

                <li @click="selectedTab = 'protocol'">
                    <a href="#tabs-protocol"><i class="fas fa-hashtag"></i> Protocolo</a>
                </li>

                <li @click="selectedTab = 'email'">
                    <a href="#tabs-email"><i class="fas fa-at"></i> E-mail</a>
                </li>

                <li @click="selectedTab = 'group'">
                    <a href="#tabs-group"><i class="fas fa-layer-group"></i> Grupo</a>
                </li>

                <li @click="selectedTab = 'priority'">
                    <a href="#tabs-priority"><i class="fas fa-bell"></i> Prioridade</a>
                </li>
            </ul>

            <div class="row" id="filters">
                <div class="col-md-12" id="tabs-data">
                    <div v-if="selectedTab == 'date'" class="filter-group">
                        <div>
                            <label for="" class="filter-select-label">Buscar por data</label>
                        </div>
                        <div class="d-flex justify-content-center">
                            <div class="col">
                                <label for="">De:</label>
                                <input type="date" class="form-control" v-model="filters.startDate">
                            </div>
                            <div class="col">
                                <label for="">Até:</label>
                                <input type="date" class="form-control" v-model="filters.endDate">
                            </div>
                            <div class="col d-flex align-items-end">
                                <button type="button" class="btn btn-primary mb-0" @click="search">
                                    <i class="fas fa-search"></i> Buscar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" id="tabs-client">
                    <div v-if="selectedTab == 'client'" class="filter-group">
                        <div>
                            <label for="" class="filter-select-label">Buscar por cliente</label>
                        </div>
                        <div class="custom-input-group">
                            <input type="text" class="form-control" placeholder="🔎 Digite o nome do cliente..."
                                v-model="filters.client">
                            <button type="button" class="btn btn-primary" @click="search"><i class="fas fa-search"></i>
                                Buscar</button>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" id="tabs-owner">
                    <div v-if="selectedTab == 'owner'" class="filter-group">
                        <div>
                            <label for="" class="filter-select-label">Buscar por operador</label>
                        </div>
                        <div class="custom-input-group">
                            <select class="form-control" name="owner-select" style="width: 75% !important;"
                                id="owner-select" v-model="filters.owner">
                                <option value="" selected disabled>🔽 Selecione o operador...</option>
                                <option v-for="op in operatorsList" :key="op.name" v-bind:value="op.name">{{ op.name }}</option>
                            </select>
                            <button type="button" class="btn btn-primary" @click="search">
                                <i class="fas fa-search"></i> Buscar
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" id="tabs-protocol">
                    <div v-if="selectedTab == 'protocol'" class="filter-group">
                        <div>
                            <label for="" class="filter-select-label">Buscar por protocolo</label>
                        </div>
                        <div class="custom-input-group">
                            <input type="text" class="form-control"
                                placeholder="🔎 Digite o protocolo do atendimento..." v-model="filters.protocol">
                            <button type="button" class="btn btn-primary" @click="search"><i class="fas fa-search"></i>
                                Buscar</button>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" id="tabs-email">
                    <div v-if="selectedTab == 'email'" class="filter-group">
                        <div>
                            <label for="" class="filter-select-label">Buscar por e-mail</label>
                        </div>
                        <div class="custom-input-group">
                            <input type="text" class="form-control" placeholder="🔎 Digite o email do cliente..."
                                v-model="filters.email">
                            <button type="button" class="btn btn-primary" @click="search"><i class="fas fa-search"></i>
                                Buscar</button>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" id="tabs-group">
                    <div v-if="selectedTab == 'group'" class="filter-group">
                        <div>
                            <label for="" class="filter-select-label">Buscar por grupo</label>
                        </div>
                        <div class="custom-input-group">
                            <select class="form-control" name="group-select" style="width: 75% !important;" id="group-select" v-model="filters.group">
                                <option value="" selected disabled>🔽 Selecione o grupo...</option>
                                <option v-for="group in groupsList" :key="group.name" v-bind:value="group.name">{{ group.name }}</option>
                            </select>
                            <button type="button" class="btn btn-primary" @click="search">
                                <i class="fas fa-search"></i> Buscar
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" id="tabs-priority">
                    <div v-if="selectedTab == 'priority'" class="filter-group">
                        <div>
                            <label for="" class="filter-select-label">Buscar por prioridade</label>
                        </div>
                        <div class="custom-input-group">
                            <select class="form-control" name="priority-select" style="width: 75% !important;" id="priority-select" v-model="filters.priority">
                                <option value="" selected disabled>🔽 Selecione uma prioridade...</option>
                                <option v-for="priority in prioritiesList" :key="priority.id" v-bind:value="priority.id">{{ priority.name }}</option>
                            </select>
                            <button type="button" class="btn btn-primary" @click="search">
                                <i class="fas fa-search"></i> Buscar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr>

        <b-row class="btn-header-table">
            <b-button variant="success" style="margin-right: -4px;" @click="generateExcel">
                <i class="fas fa-file-excel"></i> Excel
                <!-- <b-icon icon="file-earmark-excel" aria-hidden="true">EXCEL </b-icon> -->
            </b-button>
            
            <b-col md="4">
                <b-form-group class="mb-1">
                    <b-input-group size="sm">
                        <b-form-input id="filter-input" v-model="filter" type="search"
                            placeholder="Digite para filtrar os resultados..."></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="12" style="overflow-x: auto;">
                <b-table striped hover bordered sort-icon-left show-empty :items="attData" :fields="visibleColumns"
                    :per-page="0" :no-local-sorting="true" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                    @sort-changed="onSortChanged" thead-class="font-weight-bold">

                    <template v-if="loading" #empty>
                        <div class="text-center">
                            <b-spinner variant="dark" small></b-spinner> Processando, por favor, aguarde...
                        </div>
                    </template>

                    <template v-else #empty>
                        <h6 style="text-align: center">Nenhum resultado encontrado.</h6>
                    </template>

                    <template #cell(email)="data">
                        {{ data.item.email[0] }}
                    </template>

                    <template #cell(priority)="data">
                        <span class="highlight-badge" :style="dinamicStyle(data.item.priority.color)">
                            <small>({{ data.item.priority?.level ?? '' }})</small>
                            {{ camelCaseString(data.item.priority?.name ?? '') }}
                        </span>
                    </template>

                    <template #cell(status)="data">
                        <span class="highlight-badge" :style="dinamicStyle(data.item.status.color)">
                            {{ camelCaseString(data.item.status?.name) }}
                        </span>
                    </template>

                    <template #cell(created_at)="data">
                        {{ formatDate(data.item.created_at) }}
                    </template>

                    <template #cell(updated_at)="data">
                        {{ formatDate(data.item.updated_at) }}
                    </template>

                    <template #cell(closed_at)="data">
                        {{ data.item.closed_at ? formatDate(data.item.closed_at) : ""}}
                    </template>

                    <template #cell(sla)="data">
                        <span v-html="handleTicketSLA(data.item, slaTick)"></span>
                    </template>

                    <template #cell(owner_user)="data">
                        {{ data.item.owner_user?.name }}
                    </template>

                    <template #cell(owner_group)="data">
                        {{ data.item.owner_group?.name }}
                    </template>

                    <template v-slot:cell(view-button)="{ item }">
                        <span class="view-button-wrapper">
                            <b-btn id="view-button" @click.prevent="showModalDetails(item)" style="border-radius: 3px !important;">
                                <i class="far fa-eye" aria-hidden="true"></i>
                                <span v-if="item?.unread_emails && item.unread_emails > 0"
                                    class="badge badge-danger notification-badge"
                                    v-b-tooltip.hover
                                    :title="dinamycTextEmails(item?.unread_emails)">
                                    {{ item?.unread_emails }}
                                </span>
                            </b-btn>
                        </span>
                    </template>
                </b-table>
            </b-col>
        </b-row>

        <b-row class="align-items-center mb-2">
            <b-col md="12">
                <p class="pagination-info-text mb-0">
                    Mostrando <strong>{{ paginationInfo.start }}</strong> a <strong>{{ paginationInfo.end }}</strong> de <strong>{{ paginationInfo.total }}</strong> registros
                </p>
            </b-col>
        </b-row>

        <b-row class="justify-content-between">
            <b-col md="4">
                <b-form-group label="Registros por página" label-for="per-page-select" label-cols-md="6"
                    label-align-sm="right" label-size="sm" class="mb-0 align-self-center">
                    <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
            </b-col>

            <b-col sm="7" md="6" class="my-1">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right" size="md"
                    class="my-0"></b-pagination>
            </b-col>
        </b-row>

        <TicketModal ref="ticketModal" :usersList="operatorsList" :groupsList="groupsList" :prioritiesList="prioritiesList" :slaTick="slaTick" @updateTicketTable="updateTable"/>
    </b-container>
</template>

<script>
import VueTheMask from 'vue-the-mask';
import TicketModal from './TicketDetailsModal.vue';
import { BSpinner } from 'bootstrap-vue';
import * as XLSX from 'xlsx';
import moment from 'moment'
import momentDuration from "moment-duration-format";
import { taskManagerAxios } from '../../tasks/connections/taskApiConnection.js';
momentDuration(moment);
import {
    dinamicStyle,
    formTelefone,
    formatDate,
    handleTicketSLA,
    isTimeWithinPercentage,
    camelCaseString,
    handleTicketSLAExpirationDate,
} from '../../../helpers/utils';

Vue.use(VueTheMask);
Vue.component('b-spinner', BSpinner);

export default {
    name: "TicketsManager",
    components: {
        TicketModal
    },
    props: {
        hasInterval: {
            type: Boolean,
            default: false
        },
        onlyOpen: {
            type: Boolean,
            default: false
        },
        hasAlert: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            fields: [
                {
                    key: 'view-button',
                    label: 'Visualizar',
                    class: 'text-center align-middle',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff', width: '100px' }
                },
                {
                    key: 'protocol',
                    label: 'Protocolo',
                    sortable: true,
                    class: 'text-center align-middle',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'created_at',
                    label: 'Criação',
                    sortable: true,
                    class: 'text-center align-middle',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'updated_at',
                    label: 'Atualização',
                    sortable: true,
                    class: 'text-center align-middle',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'email_config',
                    label: 'Email de Entrada',
                    sortable: true,
                    class: 'text-center align-middle',
                    thStyle: {
                        backgroundColor: '#1c869a',
                        color: '#ffffff',
                        width: '300px',
                        maxWidth: '300px',
                        minWidth: '170px'
                    },
                    tdAttr: { style: 'width: 300px; max-width: 300px; min-width: 170px ; overflow-wrap: anywhere;' }
                },
                {
                    key: 'client',
                    label: 'Cliente',
                    sortable: true,
                    class: 'text-center align-middle',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'email',
                    label: 'E-mail',
                    sortable: true,
                    class: 'text-center align-middle',
                    thStyle: {
                        backgroundColor: '#1c869a',
                        color: '#ffffff',
                        width: '300px',
                        maxWidth: '300px',
                        minWidth: '170px'
                    },
                    tdAttr: { style: 'width: 300px; max-width: 300px; min-width: 170px ; overflow-wrap: anywhere;' }
                },
                {
                    key: 'subject',
                    label: 'Assunto',
                    sortable: true,
                    class: 'text-center align-middle',
                    thStyle: {
                        backgroundColor: '#1c869a',
                        color: '#ffffff',
                        width: '300px',
                        maxWidth: '300px',
                        minWidth: '170px'
                    },
                    tdAttr: { style: 'width: 300px; max-width: 300px; min-width: 170px ; overflow-wrap: anywhere;' }
                },
                {
                    key: 'priority',
                    label: 'Prioridade',
                    sortable: true,
                    sortByFormatted: this.sortComparePriority,
                    class: 'text-center align-middle',
                    thStyle: {
                        backgroundColor: '#1c869a',
                        color: '#ffffff',
                        width: '200px',
                        maxWidth: '200px',
                        minWidth: '150px'
                    },
                    tdAttr: { style: 'width: 200px; max-width: 200px; min-width: 150px ; overflow-wrap: anywhere;' }
                },
                {
                    key: 'sla',
                    label: 'SLA',
                    sortable: true,
                    sortByFormatted: this.sortCompareSLA,
                    class: 'text-center align-middle',
                    thStyle: {
                        backgroundColor: '#1c869a',
                        color: '#ffffff',
                        width: '300px',
                        maxWidth: '300px',
                        minWidth: '170px'
                    },
                    tdAttr: { style: 'width: 300px; max-width: 300px; min-width: 170px ; overflow-wrap: anywhere;' }
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true,
                    sortByFormatted: this.sortCompareStatus,
                    class: 'text-center align-middle',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'owner_user',
                    label: 'Atendente',
                    sortable: true,
                    class: 'text-center align-middle',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'owner_group',
                    label: 'Grupo',
                    sortable: true,
                    class: 'text-center align-middle',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'closed_by',
                    label: 'Finalizado por',
                    sortable: true,
                    class: 'text-center align-middle',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'closed_at',
                    label: 'Finalizado',
                    sortable: true,
                    class: 'text-center align-middle',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
            ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, { value: 100, text: "Ver mais" }],
            sortBy: sessionStorage.getItem('tickets_sortBy') ?? 'updated_at',
            sortDesc: sessionStorage.getItem('tickets_sortDesc') !== null
                ? sessionStorage.getItem('tickets_sortDesc') === 'true'
                : true,
            sortDirection: 'asc',
            filter: null,
            intervalSearch: null,
            selectedTab: 'date',
            filterToRequest: "all",
            attData: [],
            filters: {
                startDate: '',
                endDate: '',
                client: '',
                owner: '',
                queue: '',
                phone: '',
                unique_key: '',
                protocol: '',
                email: '',
                group: '',
                priority: '',
            },
            operatorsList: [],
            groupsList: [],
            prioritiesList: [],
            alerts: [],
            slaTick: 0,
            slaInterval: null,
            searchDebounce: null,
        }
    },
    mounted() {
        if (location.pathname === '/ticket_history') changeTVMode("full");
        this.slaInterval = setInterval(() => {
            this.slaTick++;
        }, 60000);
    },
    beforeDestroy() {
        if (this.slaInterval) clearInterval(this.slaInterval);
    },
    created() {
        if (this.hasInterval) {
            this.searchInterval("all");
        } else {
            this.getTickets("all");
            this.intervalCheckSLA();
        }
        this.getOperators();
        this.getPriorities();
        this.getGroups();
        
    },
    computed: {
        visibleColumns() {
            if (!this.onlyOpen) return this.fields;
            return this.fields.filter(item =>
                item.key != 'closed_at' &&
                item.key != 'closed_by'
            )
        },
        paginationInfo() {
            const start = (this.currentPage - 1) * this.perPage + 1;
            const end = Math.min(this.currentPage * this.perPage, this.totalRows);
            return {
                start: this.totalRows > 0 ? start : 0,
                end: end,
                total: this.totalRows
            };
        },
    },
    methods: {
        dinamicStyle,
        formTelefone,
        formatDate,
        handleTicketSLA,
        isTimeWithinPercentage,
        camelCaseString,
        handleTicketSLAExpirationDate,
        sortComparePriority(value) {
            return value?.level ?? 0;
        },
        sortCompareSLA(value, key, item) {
            const expireIn = moment(item.created_at).add(value, "seconds");
            return expireIn.unix();
        },
        sortCompareStatus(value) {
            const statusOrder = { 
                'pendente': 1, 
                'aguardando': 2, 
                'em andamento': 3, 
                'resolvido': 4, 
                'concluído': 5 
            };
            return statusOrder[value.name] ?? 0;
        },
        intervalCheckSLA() {
            for (const att of this.attData) {
                if (this.alerts.includes(att.id)) return;
                const valid = this.isTimeWithinPercentage(att.sla, att.created_at, att.priority?.percent_alert ?? 0);
                if (valid) {
                    const audio = new Audio('/sounds/ticket-notification.mp3');
                    audio.play();
                    this.alerts.push(att.id);
                };
                break;
            }
        },
        checkTicketFinishedOnTime(ticket) {
            const slaExpirationDate = this.handleTicketSLAExpirationDate(ticket);
            if (slaExpirationDate === '-') return 'NÃO';
            const expireAt = moment(slaExpirationDate, 'DD/MM/YYYY HH:mm:ss');
            if (ticket.closed_at) {
                const closedAt = moment(ticket.closed_at);
                return closedAt.isBefore(expireAt) || closedAt.isSame(expireAt) ? 'SIM' : 'NÃO';
            }

            const now = moment();
            return now.isBefore(expireAt) || now.isSame(expireAt) ? 'SIM' : 'NÃO';
        },
        async generateExcel() {
            try {
                Swal.fire({
                    title: "Exportando...",
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    html: '<div class="d-flex justify-content-center my-3"><i class="fa fa-spinner fa-spin fa-3x"></i></div><p>Gerando arquivo Excel, aguarde...</p>',
                });
                const { data } = await axios.get('/ticket/getTicketsByFilter', {
                    params: {
                        typeFilter: this.filterToRequest,
                        start: this.filters.startDate,
                        end: this.filters.endDate,
                        client: this.filters.client,
                        owner: this.filters.owner,
                        protocol: this.filters.protocol,
                        email: this.filters.email,
                        group: this.filters.group,
                        priority: this.filters.priority,
                        onlyOpen: this.onlyOpen,
                        search: this.filter,
                        all: true,
                    }
                });
                Swal.close();
                const items = Array.isArray(data) ? data : [];
                if (items.length < 1) {
                    Swal.fire({ type: "info", text: "Nenhum registro encontrado para exportar!" });
                    return;
                }
                const normalize = (val) => String(val ?? '').trim();
                const taskItems = await this.fetchTasksForPeriod();
                const taskByRefProtocol = new Map();
                taskItems.forEach(item => {
                    const refProtocol = normalize(item?.ref_protocol);
                    if (refProtocol) {
                        taskByRefProtocol.set(refProtocol, item?.protocol ?? '');
                    }
                });

                const fieldsExcel = items.map(item => {
                    const ticketRef = normalize(item?.protocol);
                    return {
                        'Protocolo': item.protocol,
                        'Data': this.formatDate(item.created_at),
                        'Cliente': item?.client ?? "",
                        'Entrada': item?.email_config ?? "",
                        'Chamado': item?.chamado ?? "",
                        'E-mail': item.email[0] ?? item.email,
                        'Assunto': item?.subject ?? "",
                        'Prioridade': item?.priority?.name ?? item.priority,
                        'Palavra-chave': this.handleKeyWords(item?.keyword, 'keyword'),
                        'Regras': this.handleKeyWords(item?.keyword, 'rule'),
                        'Status': item?.status?.name ?? item.status,
                        'Grupo': item?.owner_group?.name ?? item.owner,
                        'Atendente': item?.owner_user ? item?.owner_user?.name : "",
                        'Vencimento': this.handleTicketSLAExpirationDate(item),
                        'Finalizado em': item.closed_at ? this.formatDate(item.closed_at) : "",
                        'Finalizado por': item.closed_by ?? "",
                        'Dentro do prazo': this.checkTicketFinishedOnTime(item),
                        'Código Tarefa': taskByRefProtocol.get(ticketRef) ?? '',
                    }
                });
                const wb = XLSX.utils.book_new();
                const ws = XLSX.utils.json_to_sheet(fieldsExcel);
                XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
                XLSX.writeFile(wb, 'tickets.xlsx');
            } catch (error) {
                Swal.close();
                console.error(error);
                Swal.fire({ type: "error", text: "Erro ao exportar Excel!" });
            }
        },
        fetchData() {
            if (this.hasInterval) {
                this.searchInterval(this.filterToRequest);
            } else {
                this.getTickets(this.filterToRequest);
            }
        },
        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            sessionStorage.setItem('tickets_sortBy', this.sortBy);
            sessionStorage.setItem('tickets_sortDesc', this.sortDesc);
            if (this.currentPage === 1) {
                this.fetchData();
            } else {
                this.currentPage = 1;
            }
        },
        async getTickets(filter) {
            this.loading = true;
            this.attData = [];
            try {
                const { data } = await axios.get('/ticket/getTicketsByFilter', {
                    params: {
                        typeFilter: filter,
                        start: this.filters.startDate,
                        end: this.filters.endDate,
                        client: this.filters.client,
                        owner: this.filters.owner,
                        protocol: this.filters.protocol,
                        email: this.filters.email,
                        group: this.filters.group,
                        priority: this.filters.priority,
                        onlyOpen: this.onlyOpen,
                        page: this.currentPage,
                        perPage: this.perPage,
                        sortBy: this.sortBy,
                        sortDesc: this.sortDesc,
                        search: this.filter,
                    }
                });
                this.attData = data.data ?? [];
                this.totalRows = data.total ?? 0;
                this.loading = false;
            } catch (error) {
                console.error(error);
                this.loading = false;
            }
        },
        async searchInterval(filter) {
            if (!this.hasInterval) return;
            clearInterval(this.intervalSearch);
            await this.getTickets(filter);
            this.intervalCheckSLA();
            this.intervalSearch = setInterval(async () => {
                await this.getTickets(filter);
                this.intervalCheckSLA();
            }, 60000);
        },
        search() {
            this.currentPage = 1;
            this.filterToRequest = this.selectedTab;
            if (this.hasInterval) {
                this.searchInterval(this.filterToRequest);
            } else {
                this.getTickets(this.filterToRequest);
            }
        },
        resetFilters() {
            this.filters = {
                startDate: '',
                endDate: '',
                client: '',
                owner: '',
                queue: '',
                phone: '',
                unique_key: '',
                email: '',
            }
        },
        async getOperators() {
            try {
                const { data } = await axios.get('/simple-list-users');
                if (data) this.operatorsList = data;
            } catch (error) {
                console.error(error);
            }
        },
        async getGroups() {
            try {
                const { data } = await axios.get('/ticket/groups');
                if (data) this.groupsList = data;
            } catch (error) {
                console.error(error);
            }
        },
        async getPriorities() {
            try {
                const { data } = await axios.get("/ticket/priority");
                if (data) this.prioritiesList = data.map(item => {
                    return {
                        id: item.id,
                        name: item.name,
                        color: item.color,
                        time: item.time,
                        level: item.level,
                        percent_alert: item.percent_alert,
                    }
                });
            } catch (error) {
                console.error(error)
            }
        },
        getUsers() {
            axios.get("/simple-list-users")
                .then(({ data }) => {
                   if (data) this.allUsers = data.map(item => {
                        return {
                            id: item.id,
                            name: item.name,
                        }
                    });
                });
        },
        async showModalDetails(ticket) {
            try {
                if (!ticket.emails ||
                    !ticket.comments ||
                    !ticket.timeline
                ) {
                    Swal.fire({
                        title: "Carregando dados do ticket.",
                        text: "Por favor, aguarde...",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        showConfirmButton: false,
                        showCancelButton: false,
                        showCloseButton: false,
                        html: '<div class="d-flex justify-content-center my-3"><i class="fa fa-spinner fa-spin fa-3x"></i></div><p>Por favor, aguarde...</p>',
                    });
                    const { data } = await axios.get(`/ticket/getTicketDetails/${ticket.id}`);
                    if (!data) {
                        Swal.fire({
                            type: "error",
                            text: "Falha ao obter detalhes do ticket!"
                        });
                        return;
                    }
                    ticket.emails = data?.emails ?? [];
                    ticket.comments = data?.comments ?? [];
                    ticket.timeline = data?.timeline ?? [];
                }
                Swal.close();
                this.$refs.ticketModal.openModal(ticket);
                const emailsMark = await this.emailsMarkAsRead(ticket.emails_ids);
                if (emailsMark) {
                    ticket.unread_emails = 0;
                };
            } catch (error) {
                Swal.close();
                console.error(error);
                Swal.fire({
                    type: "error",
                    text: "Falha ao obter detalhes do ticket!"
                });
            }
        },
        updateTable(data) {
            if (!data.id) return;
            const found = this.attData.find(el => el.id === data.id);
            if (!found) return;
            if (this.onlyOpen && data?.status?.is_finisher) {
                // se o ticket estiver concluido e a tabela marcada para apenas abertos, remove o ticket
                this.attData = this.attData.filter(item => item.id != found.id);
            } else {
                if (
                    (data?.timeline && data.timeline?.length > 0) &&
                    (found?.timeline && found.timeline?.length > 0)
                ) {
                    found.timeline.push(...data.timeline);
                    delete data.timeline;
                };
                Object.assign(found, data);
            }
        },
        async emailsMarkAsRead(emails) {
            if (!emails || !Array.isArray(emails)) return false;
            try {
                const { data } = await axios.put("/emails/markAllAsRead", { emails });
                return !!data;
            } catch (error) {
                console.error(error);
                return false;
            }
        },
        dinamycTextEmails(emails) {
            return `Há ${emails} e-mail${emails > 1 ? 's' : ''} não lido${emails > 1 ? 's' : ''}`;
        },
        handleKeyWords(keyword, type = 'keyword') {
            if (!keyword || !keyword?.keyword) return '';
            if (!keyword?.type) return keyword.keyword;
            if (keyword.type != type) return '';
            if (keyword.type === 'keyword') return keyword.keyword;
            if (keyword.type === 'rule') {
                const emails = keyword?.emails?.length > 0 ? keyword?.emails.join(";") : '';
                const domains = keyword?.domains?.length > 0 ? keyword?.domains.join(";") : '';
                return `${keyword.keyword}: ${emails};${domains}`;
            };
            return keyword;
        },
        async fetchTasksForPeriod() {
            try {
                const { data } = await taskManagerAxios.get('/tasks', {
                params: { all: true },
                });

                let items = Array.isArray(data) ? data : [];
                items = items.filter(item => item?.ref_protocol);
                return items;
            } catch (error) {
                console.error('Erro ao buscar tarefas:', error);
                return [];
            }
        },
    },
    watch: {
        selectedTab() {
            this.resetFilters();
        },
        currentPage() {
            this.fetchData();
        },
        perPage() {
            if (this.currentPage === 1) {
                this.fetchData();
            } else {
                this.currentPage = 1;
            }
        },
        filter() {
            clearTimeout(this.searchDebounce);
            this.searchDebounce = setTimeout(() => {
                if (this.currentPage === 1) {
                    this.fetchData();
                } else {
                    this.currentPage = 1;
                }
            }, 500);
        },
        async hasInterval(value) {
            if (!value) return clearInterval(this.intervalSearch);
            this.searchInterval(this.filterToRequest);
        }
    },
}
</script>

<style scoped>

.btn-header-table {
    margin-left: 1px;
    justify-content: space-between;
}

.custom-input-group {
    display: flex;
    height: 5em;
    justify-content: center;
    align-items: center;
}

.filter-select-group {
    display: flex;
    flex-direction: row;
    padding: 10px;
}

.filter-select-group input {
    height: 1.5em;
    width: 2em;
    margin: 0px;
    padding: 10px;
}

.filter-select-group input:focus {
    box-shadow: none;
}

.filter-select-group label {
    margin: 0px 0px 0px 5px;
    font-size: 12px;
    align-self: center;
}

.filter-group {
    display: flex;
    flex-direction: column;
    margin: 0px;
}

.filter-group input {
    width: 70%;
    margin: 5px;
}

.filter-group input[type='date'] {
    width: 100%;
    margin: 0;
}

.filter-group button {
    margin: 5px;
    height: 2.5em;
    border-radius: 5px !important;
}

.filter-select-label {
    font-weight: bold;
    font-size: 18px;
    align-self: center
}

.highlight-badge  {
    padding: 5px 10px;
    border-radius: 5px !important;
    font-weight: bold;
}

.highlight-badge > small {
    font-size: 10px;
}

#tickets-container {
    margin: 10px;
}

.view-button-wrapper {
    position: relative;
    display: inline-block;
}

#view-button {
    background: none;
    border: none;
    padding: 0;
    box-shadow: none;
    outline: none;
}

#view-button i {
    color: #1c869a;
    font-size: 22px;
}

#view-button i:hover {
    color: #31bdda;
    transition: 0.5s;
}

.notification-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    min-width: 18px;
    height: 18px;
    padding: 2px 5px;
    font-size: 10px;
    font-weight: bold;
    border-radius: 50% !important;
    display: flex;
    align-items: center;
    justify-content: center;
}

label {
    flex: 3;
}

input[type=radio] {
    flex: 1;
    align-self: center;
}

.pagination-info-text {
    font-size: 14px;
    color: #495057;
    text-align: center;
    padding: 10px 0;
}
</style>